// src/components/RecordCoverBand.jsx
//
// Shared Medium cover wash for record drawers (extracted from the merged
// PROJECT-COVER-IMAGE treatment, Task #9082; reused by the office drawer in
// Task #9085). Presentation only: callers own media selection/authorization
// and pass a { id, src, caption } descriptor or null for the plain header.
import { useEffect, useState } from "react";
import { T } from "../app/tokens.js";

export function CoverLayer({ cover }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [cover.src]);
  return (
    <div aria-hidden="true" data-testid="record-drawer-cover-layer" style={{ position: "absolute", inset: 0, overflow: "hidden", pointerEvents: "none", zIndex: 0 }}>
      {!failed && <img key={cover.src} data-testid="record-drawer-cover-img" src={cover.src} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)}
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block" }} />}
      <div style={{ position: "absolute", inset: 0, background: T.coverWashHorizontal }} />
      <div style={{ position: "absolute", inset: 0, background: T.coverWashVertical }} />
    </div>
  );
}

// No cover: children render directly in the body (plain-header parity, same
// margins and selectors). Cover: a reserved-height band behind the header.
// `minHeight` is a scoped sizing override (Office uses its fixed header
// envelope); omitted, the shared T.coverMinHeight default is unchanged.
export function CoverBand({ cover, children, minHeight, marginBottom = 14 }) {
  if (!cover) return children;
  return (
    <div data-testid="record-drawer-cover" data-cover-id={cover.id}
      style={{ position: "relative", minHeight: minHeight ?? T.coverMinHeight, boxSizing: "border-box", marginBottom, "--cover-solid": T.tint || T.lightGray }}>
      <CoverLayer cover={cover} />
      <div style={{ position: "relative", zIndex: 1 }}>{children}</div>
    </div>
  );
}

